import React from 'react';
import Request from './Request';
import HowItWorks from './HowItWorks';
import PriceList from './PriceList';
import SampleSickNote from './SampleSickNote';
import ValidateButton from './ValidateButton';
import FAQ from './FAQ';

const SickNoteArea = () => {
  return (
    <>
      <section id="sicknote-area">
        <div className="container">
          <Request />
          <HowItWorks />
          <PriceList />
          <SampleSickNote />
          <ValidateButton />
          <FAQ />
        </div>
      </section>
    </>
  );
};

export default SickNoteArea;
